<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>入金手数料明細</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div style="display: flex;">
            <div class="table-responsive">
                <div>
                    <table mat-table [dataSource]="dataSource" style="min-width: 255px;">
                        <ng-container matColumnDef="fee">
                            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef
                                style="min-width: 150px;">
                                手数料名称</th>
                            <td mat-cell *matCellDef="let row">{{row.fee}}</td>
                        </ng-container>

                        <ng-container matColumnDef="feeMny">
                            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef
                                style="min-width: 105px;">
                                手数料金額[円]</th>
                            <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.feeMny | number}}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsCol;sticky:true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
                    </table>
                </div>
            </div>
            <mat-card-actions style="margin-left: 40px; margin-top: 10px;" class="commission-button tw-content-end">
                <button type="button" mat-raised-button color="primary" class="btn"
                    [disabled]="isResistButtonDisabled()" (click)="onClickRegist()">手数料登録</button>
            </mat-card-actions>
            <mat-card-actions style="margin-left: 40px; margin-top: 10px" class="commission-button tw-content-end">
                <button type="button" mat-raised-button color="primary" class="btn" [disabled]="isEditButtonDisabled()"
                    (click)=" onClickEdit()">手数料訂正</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>